export class PureLink {
    constructor(socket, log) {
        this.socket = socket;
        this.numberOfVideoOutputs = 4;
        this.version = '1.2.3';
        this.videoOutputs = Array(16).fill('01');
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /\*(\d+)\?VERSIONCT!/i,
                callback: (match) => {
                    this.socket.send(`*${match[1]}s?VERSIONCT:UX-4400-CT-V${this.version}!`);
                },
            },
            {
                name: 'getVideoSwitch',
                regExp: /\*(\d+)\?O(\d+)!/i,
                callback: (match) => {
                    const outputNum = parseInt(match[2], 10) - 1;
                    this.socket.send(`*${match[1]}s?I${this.videoOutputs[outputNum]}O${match[2]}!`);
                },
            },
            {
                name: 'presetCall',
                regExp: /\*(\d+)PC(\d+)!/i,
                callback: (match) => {
                    const response = this.matrixRouting(`*${match[1]}sC`);
                    this.socket.send(`${response}!`);
                },
            },
            {
                name: 'presetStatus',
                regExp: /\*(\d+)\?PC(\d+)!/i,
                callback: (match) => {
                    const response = this.matrixRouting(`*${match[1]}?sC`);
                    this.socket.send(`${response}!`);
                },
            },
            {
                name: 'videoSwitch',
                regExp: /\*(\d+)CI(\d+)O(\d+)!/i,
                callback: (match) => {
                    const outputNum = parseInt(match[3], 10) - 1;
                    this.videoOutputs[outputNum] = match[2] ? match[2] : '01';
                    this.socket.send(`*${match[1]}sCI${match[2]}O${match[3]}!`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`Command incorrect`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        this.numberOfVideoOutputs = Object.keys((_a = config === null || config === void 0 ? void 0 : config.videoOutputs) !== null && _a !== void 0 ? _a : {}).length;
    }
    matrixRouting(preamble) {
        let response = preamble;
        for (let i = 0; i < this.numberOfVideoOutputs; i++) {
            const outputName = (i + 1).toString().padStart(2, '0');
            response += `I${this.videoOutputs[i]}O${outputName}`;
            if (i !== this.numberOfVideoOutputs - 1) {
                response += ',';
            }
        }
        return response;
    }
}
PureLink.emulatorType = 'socketEmulator';
PureLink.key = '-MSdGliCxVWRPvQPlGUo';
